<script>
    import { filteredCollection } from "./../utils/store.js";
    import { fade } from "svelte/transition";
</script>

<div id="js-search-list">
    {#each $filteredCollection as item, index (item)}
        <div class="list_element">
            <h4><a href="/news-page/{item.slug}">{item.title}</a></h4>
            <div class="list_box">
                <div class="wyswig">{item.intro}</div>
            </div>
        </div>
    {/each}
</div>
